const BiopsyContent = () => {
    return (
        <>
            <h4>
                Sentinel lymph node biopsy
            </h4>
            <p>
                The introduction of sentinel lymph node biopsy, which has since spared many women the adverse effects of axillary clearance surgery, without compromising the rate of cancer recurrence.
            </p>
        </>
    );
}

export default BiopsyContent;